import React from 'react';

//Components
import GenericHeader from '@common-components/pageHeader/GenericHeader';
import Text from '@common-components/form/Text';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';

export const RenderNoRecordFound = ({ clearData, startNewApplication }) => {
    return(
        <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id="ede-search-result__found-records">
            <div className="member__name">
                <GenericHeader
                    id='header'
                    text='selfDesignation.search.searchResult.modal.header.noMatchFound'
                    tag='h3'
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}

                />
            </div>
            <div className='grid-row flex-row' id='ede-search-result__member-info'>
                <Text
                    id='no_result_message'
                    text='selfDesignation.search.searchResult.modal.message.noMatchFound'
                    display='block'
                />
            </div>
            <div className='grid-col-12 action__btn__wrapper padding-b-0'>
                <Button
                    { ...{
                        id:'clear-btn',
                        name:'clearBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display-inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.cancel',
                        handleClick: clearData
                    }}

                />
                <Button
                    { ...{
                        id:'start-new-app-btn',
                        name:'startNewApplicationBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display-inline'],
                        classes:['gi-button__primary'],
                        btnText:'selfDesignation.search.action-btn.startNewApplication',
                        handleClick: startNewApplication
                    }}

                />
            </div>
        </div>
    );
};